import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { useCsRoutes } from '@shared/api'
import { trackEvent } from '@shared/lib/amplitude'

export interface ShowLessonResult {
  booking: Booking
  isLastLesson: boolean
}

interface ShowLessonApiReturn {
  showLesson: (bookingId: number) => Promise<ShowLessonResult | null>
}

export const useShowLessonApi = (): ShowLessonApiReturn => {
  const { $axios } = useNuxtApp()

  const showLesson = async (bookingId: number): Promise<ShowLessonResult | null> => {
    const url = useCsRoutes('classroom.lessons.show', {
      '[booking_id]': bookingId,
    })

    if (!url) {
      console.warn('missing url for classroom/show-lesson.hook.ts')
      return null
    }

    try {
      const { data } = await $axios.get(url)

      if (data?.success && data?.data?.booking) {
        return {
          booking: data.data.booking as Booking,
          isLastLesson: Boolean(data.data.is_last_lesson),
        }
      }

      return null
    } catch (err: any) {
      console.error('unable to retrieve classroom/show-lesson.hook.ts:', err)

      trackEvent('Request_error', {
        feature: 'classroom',
        name: 'show_lesson',
        booking_id: bookingId,
        error_code: err?.response?.status ?? err?.code ?? null,
        error_message: err?.message ?? 'Unknown error',
      })

      return null
    }
  }

  return { showLesson }
}